var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeganism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Vegan-Food-Sign-Symbol--Streamline-Freehand.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Vegan Food Sign Symbol Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.8 4.89a0.38 0.38 0 0 0 0 -0.51 0.36 0.36 0 0 0 -0.51 0 32.42 32.42 0 0 0 -6.39 8c-0.46 0.79 0.27 1.41 0.81 0.77 0.32 -0.6 0.53 -0.93 0.88 -1.52a32.26 32.26 0 0 1 5.21 -6.74Z",
    fill: "#B557F7",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.27 0.68a0.6 0.6 0 0 0 -0.15 -0.48 0.61 0.61 0 0 0 -0.45 -0.2 14.3 14.3 0 0 0 -5.11 1.09 13.85 13.85 0 0 0 -6.11 4.73 7.89 7.89 0 0 0 -0.68 8.33s-1.28 2.72 -1.84 4S8 20.38 7.6 21.4a28.81 28.81 0 0 0 -2 -5.13 19.42 19.42 0 0 0 -4.5 -5.91 0.31 0.31 0 0 0 -0.44 0 0.32 0.32 0 0 0 0 0.44 19 19 0 0 1 4.09 5.86 30.27 30.27 0 0 1 2.15 6.85 0.61 0.61 0 0 0 0.55 0.47 0.59 0.59 0 0 0 0.59 -0.4c0.57 -1.67 1.39 -3.75 2.39 -6 0.43 -0.94 0.88 -1.9 1.37 -2.87a4.31 4.31 0 0 0 0.79 0.35 7.58 7.58 0 0 0 2.65 0.39 8.47 8.47 0 0 0 5.26 -2 7.94 7.94 0 0 0 2.76 -4.95 13.08 13.08 0 0 0 0.12 -1.65c0.05 -2 -0.38 -4.08 -0.11 -6.17Zm-1.09 7.76a6.86 6.86 0 0 1 -2.29 4.35 7.5 7.5 0 0 1 -4.65 1.87 6.87 6.87 0 0 1 -2 -0.16 3 3 0 0 1 -2.18 -1.69 7.42 7.42 0 0 1 1.13 -6.46A13.26 13.26 0 0 1 18 2.16a14 14 0 0 1 4 -0.93l0 1c0 2.04 0.44 4.12 0.18 6.21Z",
    fill: "#8841B9",
    fillRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeganism);
export default __webpack_public_path__ + "static/media/veganism.17669e3c4fac082df3157d06e508490b.svg";
export { ForwardRef as ReactComponent };